module.exports = __webpack_public_path__ + "img/Aa3.40a1f8ab.png";